import Reveal from './Reveal'

const steps = [
  { title: 'Discovery', desc: 'We learn your domain before we write a line of code. We meet the people who run the business and the people who run the system.' },
  { title: 'Design', desc: 'We agree the architecture in writing. Every major choice is reviewed by you before we build on it.' },
  { title: 'Develop', desc: 'Tested, reviewed, production-grade engineering. You see working software early and often.' },
  { title: 'Deploy', desc: 'We ship to production and operate the system with you, not hand it over and leave.' },
]

export default function Process() {
  return (
    <section id="how-we-work" aria-labelledby="process-title" className="bg-parchment text-ledger py-24 md:py-32">
      <div className="container mx-auto px-6">
        <Reveal>
          <p className="site-label text-brass">03 · How we work</p>
          <h2 id="process-title" className="site-display text-4xl md:text-5xl mt-5 max-w-3xl">
            Four stages. Nothing is hidden between them.
          </h2>
        </Reveal>

        <Reveal>
          <ol className="mt-16 grid md:grid-cols-4 border-t-2 border-mariner">
            {steps.map((s, i) => (
              <li key={s.title} className="pt-8 pb-4 md:pr-8 md:border-l border-rule md:first:border-l-0 md:pl-8 md:first:pl-0">
                <span className="font-brandMono text-sm text-brass">{String(i + 1).padStart(2, '0')}</span>
                <h3 className="font-brandSerif font-semibold text-2xl mt-4">{s.title}</h3>
                <p className="text-base leading-relaxed text-ledger/80 mt-3">{s.desc}</p>
              </li>
            ))}
          </ol>
        </Reveal>
      </div>
    </section>
  )
}
